import type { Breakpoints } from "../../../theme/theme.type";

export const NAVIGATION_MENU_HEIGHT_STYLED_UNITS = "x8";
export const NAVIGATION_MENU_CONTENT_WIDTH_MAX_WIDTH_PX = 400;
export const NAVIGATION_DEFAULT_BREAKPOINT_THEME_KEY: keyof Breakpoints = "medium";
export const NAVIGATION_SUB_MENU_MIN_WIDTH_PX = 180;
export const MIN_DISTANCE_BETWEEN_MENUS_PX = 64;
